import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Card } from '../components/ui/card';

const Gallery = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [isVideo, setIsVideo] = useState(false);

  const videos = [
    { url: 'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/t0p68xto_0BA4A318-BFCD-4F4A-A152-7E9C2290C65D.mov', title: 'Détail intérieur' },
    { url: 'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/v2kgbull_8A1B92EE-DD31-4344-8DB3-DE2DD974F8DD.mov', title: 'Nettoyage extérieur' },
    { url: 'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/4769xjdr_3CB22E70-31FB-4125-AD74-DA6930B5AF4A.mov', title: 'Finitions' },
    { url: 'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/f6qcou8h_915B3D07-BC4C-4643-8646-FB38D0A0CB4B.mov', title: 'Résultat final' },
    { url: 'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/opqcoal6_8436BCF9-38B2-4DCB-A081-8DEC7BD716FD.mov', title: 'Nettoyage complet' }
  ];

  const photos = [
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/8z55ukfy_IMG_4274.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/frnjm5p4_IMG_4275.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/aquxaeuh_IMG_4276.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/qsizhbal_IMG_4278.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/4hb9e4cv_IMG_4280.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/yxcyufc4_IMG_4283.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/2y2kuqbl_IMG_4284.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/2fskoima_IMG_4286.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/nvb6xstt_IMG_4287.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/ns22aqfx_IMG_4285.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/phlpdo7c_IMG_4288.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/ppdf4kyt_IMG_4289.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/74r35pfp_IMG_4290.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/aa1z17vs_IMG_4302.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/di4k0m6v_IMG_4301.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/75kckhe4_IMG_4300.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/94egxwcg_IMG_4299.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/zgyvmurc_IMG_4305.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/bqzlshq7_IMG_4304.jpg',
    'https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/cwwrtih7_IMG_4303.jpg'
  ];

  const openMedia = (url, video = false) => {
    setSelectedMedia(url);
    setIsVideo(video);
  };

  const closeMedia = () => {
    setSelectedMedia(null);
    setIsVideo(false);
  };

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-gray-950 to-black">
        <div className="container mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-fade-in">
            Nos <span className="text-blue-500">Réalisations</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto animate-slide-up">
            Découvrez nos transformations automobiles. Chaque véhicule est traité avec le plus grand soin pour un résultat impeccable.
          </p>
        </div>
      </section>

      {/* Videos Section */}
      <section className="py-16 px-4 bg-black">
        <div className="container mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            <span className="text-blue-500">Vidéos</span> de nos prestations
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {videos.map((video, index) => (
              <Card 
                key={index}
                className="bg-gray-900/50 border-blue-500/30 overflow-hidden hover:border-blue-500/50 transition-all duration-300 hover:scale-105 cursor-pointer"
                onClick={() => openMedia(video.url, true)}
              >
                <div className="relative aspect-video bg-gray-800">
                  <video 
                    src={video.url}
                    className="w-full h-full object-cover"
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-white">{video.title}</h3>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Photos Section */}
      <section className="py-16 px-4 bg-gradient-to-b from-black to-gray-950">
        <div className="container mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Galerie <span className="text-blue-500">Photos</span>
          </h2>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-7xl mx-auto">
            {photos.map((photo, index) => (
              <div 
                key={index}
                className="relative aspect-square overflow-hidden rounded-lg cursor-pointer group"
                onClick={() => openMedia(photo, false)}
              >
                <img 
                  src={photo}
                  alt={`Réalisation AutoClean ${index + 1}`}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 px-4 bg-gray-950">
        <div className="container mx-auto text-center max-w-3xl">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Prêt pour une transformation ?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Réservez dès maintenant et donnez à votre véhicule l'éclat qu'il mérite.
          </p>
          <a href="tel:0766845519">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 text-lg rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-blue-500/50">
              Prendre rendez-vous
            </button>
          </a>
        </div>
      </section>

      {/* Modal for full view */}
      {selectedMedia && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={closeMedia}
        >
          <button 
            className="absolute top-4 right-4 text-white hover:text-blue-500 transition-colors"
            onClick={closeMedia}
          >
            <X className="h-8 w-8" />
          </button>
          
          <div className="max-w-6xl max-h-[90vh] w-full" onClick={(e) => e.stopPropagation()}>
            {isVideo ? (
              <video 
                src={selectedMedia}
                controls
                autoPlay
                className="w-full h-full max-h-[90vh] object-contain"
              />
            ) : (
              <img 
                src={selectedMedia}
                alt="Réalisation AutoClean"
                className="w-full h-full max-h-[90vh] object-contain"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
